









































import { Component, Vue } from "vue-property-decorator";

declare global {
  interface Window {
    blogArray: any;
  }
}

@Component
export default class Referenzen extends Vue {
  blogArray: any = [];
  filter: any = [];

  mounted() {
    if (window.blogArray !== undefined)
      this.blogArray = window.blogArray;
    if (this.blogArray) this.createFilter(this.blogArray);
  }

  createFilter(referenzen: any) {
    for (const referenz of referenzen) {
      if (!this.filter.includes(referenz.kategorie))
        this.filter.push(referenz.kategorie);
    }
  }

  changeFilter(e: any) {
    for (const referenz of this.blogArray) {
      if (e.target.value === "Alle Kategorien") {
        referenz.active = true;
      } else {
        if (referenz.kategorie === e.target.value) {
          referenz.active = true;
        } else {
          referenz.active = false;
        }
      }
    }
  }
}
